import React, { SFC } from 'react';
import { IProductData } from 'interfaces/IProductData';
import Translate from 'components/Translate';
import { CurrencyFormat } from 'components/CurrencyFormat';
import { paymentService } from 'services/PaymentService';
import MultipleInstallments from 'components/Cart/Price/MultipleInstallments';
import WithoutInstallment from 'components/Cart/Price/WithoutInstallment';

interface IPriceProps {
  cart: IProductData;
}

// tslint:disable-next-line:variable-name
export const SubscriptionWithoutTaxTrial: SFC<IPriceProps> = props => {
  const { cart } = props;

  return (
    <div className="chk-subscription">
      <div className="chk-subscription__text">
        <Translate term="Assinatura" />
      </div>
      <div className="chk-subscription__value theme-label">
        {cart.installments.length > 1 ? <MultipleInstallments cart={cart} isTicket={false} /> : <WithoutInstallment cart={cart} />}{' '}
      </div>
      <div className="chk-subscription__frequency">
        <Translate
          term={`a cada {frequency} ${paymentService.getNormalizedFrequencyType(cart.subscription.frequencyType, cart.subscription.frequency)}`}
          properties={{
            tax: <CurrencyFormat value={cart.subscription.tax} />,
            frequency: cart.subscription.frequency
          }}
        />
      </div>
    </div>
  );
};
